import { render, staticRenderFns } from "./FaceFront.vue?vue&type=template&id=481729fc&scoped=true"
var script = {}
import style0 from "./FaceFront.vue?vue&type=style&index=0&id=481729fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481729fc",
  null
  
)

export default component.exports